export default __webpack_public_path__ + "static/media/photo_library.fdb56ac2.svg";